var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbsDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9668 2.73632H20.6368C21.2028 2.72631 21.7527 2.92446 22.1822 3.29314C22.6117 3.66183 22.8909 4.17538 22.9668 4.73632V11.7363C22.8909 12.2973 22.6117 12.8108 22.1822 13.1795C21.7527 13.5482 21.2028 13.7463 20.6368 13.7363H17.9668M10.9668 15.7363V19.7363C10.9668 20.532 11.2829 21.295 11.8455 21.8576C12.4081 22.4203 13.1711 22.7363 13.9668 22.7363L17.9668 13.7363V2.73632H6.6868C6.20447 2.73087 5.73642 2.89992 5.36889 3.21232C5.00136 3.52472 4.75912 3.95942 4.6868 4.43632L3.3068 13.4363C3.26329 13.723 3.28262 14.0156 3.36346 14.2941C3.44429 14.5725 3.58469 14.83 3.77494 15.0488C3.96518 15.2676 4.20072 15.4424 4.46523 15.5611C4.72973 15.6798 5.01689 15.7396 5.3068 15.7363H10.9668Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/thumbs-down.1956fae2.svg";
export { ForwardRef as ReactComponent };